<p>stlyeguide works!</p>

<label>Offer guide</label>
<app-offer-item></app-offer-item>
